<template>
    <b-nav class="nav-toggled">
        <b-nav-item-dropdown no-caret :text="$t('rtaTitle')" id="rta-menu" class="toggled" left>
            <b-dropdown-item class="drop-item" v-if="true" :title="$t('rtaDashboard')" to="/rta/dashboard">
                <img class="dropItem" src="@/assets/rta/rtadashboard.svg" alt="Dashboard RTA" />
                {{ this.$t('rtaDashboard') }}
            </b-dropdown-item>
            <b-dropdown-item class="drop-item" v-if="true" :title="$t('rtaList')" to="/rta/list">
                <img class="dropItem" src="@/assets/rta/rtatable.svg" alt="Consultar RTA" />
                {{ this.$t('rtaList') }}
            </b-dropdown-item>
            <b-dropdown-item class="drop-item" v-if="true" :title="$t('rtaTriggerList')" to="/rta/triggers">
                <img class="dropItem" src="@/assets/pop2.png" alt="Gatilhos Disparados RTA" />
                {{ this.$t('rtaTriggerList') }}
            </b-dropdown-item>
            <b-dropdown-item class="drop-item"
                v-if="user.Permissions.rtaconfigurarindicadoresgerenciais && user.Permissions.rtaconfigurarindicadoresgerenciais.allowed == true && user.Permissions.rtaconfigurarindicadoresgerenciais.permission"
                :title="$t('rtaConfigureIndicators')" to="/rta/configuration">
                <img class="dropItem" src="@/assets/rta/rtaconfigind.svg" alt="Configurar Indicadores Gerenciais" />
                {{ this.$t('rtaConfigureIndicators') }}
            </b-dropdown-item>
            <b-dropdown-item class="drop-item" v-if="true" :title="$t('rtaListIndicators')" to="/rta/indicators">
                <img class="dropItem" src="@/assets/rta/rtalist.svg" alt="Listar Indicadores Gerenciais" />
                {{ this.$t('rtaListIndicators') }}
            </b-dropdown-item>
            <b-dropdown-item class="drop-item"
                v-if="user.Permissions.rtacriarmanualmente && user.Permissions.rtacriarmanualmente.allowed == true && user.Permissions.rtacriarmanualmente.permission"
                :title="$t('rtaCreateManual')" @click="forceReload">
                <img class="dropItem" src="@/assets/rta/rtacreate.svg" alt="Criar RTA Manual" />
                {{ this.$t('rtaCreateManual') }}
            </b-dropdown-item>
        </b-nav-item-dropdown>
    </b-nav>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "RTADropdown",
    computed: mapState(["user", "system"]),
    methods: {

        forceReload() {
            if (this.$route.name === "rtadetails") {
                this.$router.replace({ path: "/temp" }); // Rota temporária
                this.$nextTick(() => {
                    this.$router.replace({
                        name: "rtadetails",
                        params: { rtaId: -9999, rtaData: undefined, isManual: true }
                    });
                });
            } else {
                this.$router.push({
                    name: "rtadetails",
                    params: { rtaId: -9999, rtaData: undefined, isManual: true }
                });
            }
        }

    }
};
</script>

<style scoped>
.txt {
    color: white;
    padding: 10px 20px;
}

img.Item {
    max-height: 37px;
    max-width: 37px;
    /* border-radius: 5px; */
    margin: auto;
}

img.dropItem {
    max-height: 25px;
    max-width: 25px;
    /* border-radius: 5px; */
    margin-right: 10px;
}

.ilink {
    margin-right: 10px;
}
</style>